// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__3O13s","required":"Label_required__3OWLO"};